/* eslint-disable import/no-unresolved */
import { useEffect, useState } from 'react';
import TableMui from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableContainer from '@material-ui/core/TableContainer';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import _ from 'lodash';
import { getComparator, stableSort } from './Table.services';
import { useAppSelector } from 'src/hooks';


export type TableOrderProp = 'asc' | 'desc' | undefined;

export type TableState = {
    order?: TableOrderProp;
    orderBy?: string | undefined;
}

export type HeadCell = {
    id: string;
    label: string
    sortable?: boolean;
    withStyle?: boolean;
}

export type TableProps = {
    order: TableOrderProp
    orderBy: string | undefined,
    bodyRows: any,
    createTableRow: (rows: any) => any
    classes?: {
        [key: string]: string
    }
    headCells?: HeadCell[],
    withEmptyCell?: boolean
}

export default function Table({ headCells, classes, withEmptyCell, order, orderBy, bodyRows, createTableRow }: TableProps) {
    const { numPage, rowsPerPage } = useAppSelector(state => state.page);
    const [componentState, setComponentState] = useState<TableState>({
        order: order ?? 'asc',
        orderBy: orderBy ?? headCells?.[0]?.id ?? ''
    });

    useEffect(() => {
        setComponentState({
            order: order,
            orderBy: orderBy
        })
    }, [order, orderBy])

    const renderTableHead = () => {
        return (
            <TableHead>
                <TableRow>
                    {_.map(headCells, (headCell: HeadCell) => (
                        <TableCell
                            align='center'
                            className={headCell.withStyle ? classes?.headingTab : classes?.heading}
                            key={headCell.id}
                            sortDirection={componentState.orderBy === headCell.id ? componentState.order : false}
                        >
                            {headCell.sortable ? (
                                <TableSortLabel
                                    active={componentState.orderBy === headCell.id}
                                    direction={componentState.orderBy === headCell.id ? componentState.order : 'asc'}
                                    onClick={() => handleRequestSort(headCell.id)}
                                >
                                    <span style={{ marginLeft: '21px' }}>{headCell.label}</span>
                                </TableSortLabel>
                            ) : (
                                headCell.label
                            )}
                        </TableCell>
                    ))}
                    {withEmptyCell && <TableCell />}
                </TableRow>
            </TableHead>
        );
    };

    const handleRequestSort = (property: string) => {
        const isAsc = componentState.orderBy === property && componentState.order === 'asc';
        setComponentState({ order: isAsc ? 'desc' : 'asc', orderBy: property });
    };

    return (
        <TableContainer>
            <TableMui className={classes?.table}>
                {renderTableHead()}
                {createTableRow(
                    stableSort(bodyRows, getComparator(componentState.order, componentState.orderBy ?? '')).slice(
                        numPage * rowsPerPage,
                        numPage * rowsPerPage + rowsPerPage
                    )
                )}
            </TableMui>
        </TableContainer>
    );
}